<mat-form-field mat-input-height-small>
  <input
    matInput
    gtm="onTextField"
    gtmAction="Vdd Mac Address edit value"
    gtmCategory="diagnosticsPage"
    [gtmOn]="['change', 'focus', 'blur']"
    [(ngModel)]="value"
    (change)="valueChange($event)"
    type="text"
    [mask]="mask"
    [patterns]="patterns"
    [dropSpecialCharacters]="true"
    [ngStyle]="{ 'width.ch': inputChWidth }"
  />
</mat-form-field>
